import types from './types'
import Vue from 'vue'

const setSiteError = (state, err) => state.siteError = err ? err : 'Sorry, the site is currently unavailable. Please try again later.'
const toggleHideAreaNav = state => state.hideAreaNav = !state.hideAreaNav
const setLoginContent = (state, loginData) => state.loginData = loginData
const setPages = (state, pages) => state.pages = pages
const setPage = (state, { page, index, childIndex }) =>  {
    console.log({ page, index, childIndex })
    if (childIndex !== -1 && childIndex !== undefined) {
        Vue.set(state.pages[index].children[childIndex], 'body', page.body)
        Vue.set(state.pages[index].children[childIndex], 'resources', page.resources)
        return
    }

    Vue.set(state.pages[index], 'body', page.body)
    Vue.set(state.pages[index], 'resources', page.resources)
}

const setPageResources = (state, { pageInd, childInd, documents }) => {
    if (childInd !== -1) Vue.set(state.pages[pageInd].children[childInd], 'resources', documents)
    else Vue.set(state.pages[pageInd], 'resources', documents)
}

const deleteResource = (state, { pageInd, childInd, resourceInd }) => {
    if (childInd !== -1) Vue.delete(state.pages[pageInd].children[childInd].resources, resourceInd)
    else Vue.delete(state.pages[pageInd].resources, resourceInd)
}

const indexExists = arg => {
    return arg !== undefined && arg !== -1
}

const updateResource = (state, { data, pageResource: {  pageIndex, pageResourceIndex, childIndex, childResourceIndex }}) => {
    if (indexExists(childIndex)) {
        if (indexExists(childResourceIndex)) Vue.set(state.pages[pageIndex].children[childIndex].resources, pageResourceIndex, data)
        else Vue.set(state.pages[pageIndex].children[childIndex], 'resources', [data])
    } else if (indexExists(pageIndex)) {
        if (indexExists(childResourceIndex)) Vue.set(state.pages[pageIndex].resources, pageResourceIndex, data)
        else Vue.set(state.pages[pageIndex], 'resources', [data])
    }
}

const setNewPage = (state, page) => {
    if (Array.isArray(state.pages)) state.pages = [ page, ...state.pages]
    else state.pages = [ page ]
}

const addPageToNav = (state, { parentInd, ...data }) => {
    const { pages } = state
    const parent = pages[parentInd]

    let alreadyExists = false

    // check to see if the page WAS an existing child element
    state.pages.forEach((page, ind) => {
        if (page.id === data.id) {
            if (!data.parentPage) {
                Vue.set(state.pages, ind, data)
                alreadyExists = true
                return
            }

            Vue.delete(state.pages, ind) // if not, it'll be moving to a child level
            return
        }

        if (page.children) {
            page.children.forEach((child, i) => {
                if (child.id === data.id) {
                    // check if it STILL has a parent page assigned, we may be moving this to the root level...
                    if (data.parentPage) {
                        // if it does, we need to check if it's moving to another parent.
                        if (child.parentPage === data.parentPage) {
                            // it's not moving, so replace it...
                            Vue.set(state.pages[ind].children, ind, data)
                            alreadyExists = true
                            return
                        }

                        // If not, delete the existing entry. Because we've deleted it, it "doesn't already exist" anymore..
                        Vue.delete(state.pages[ind].children, i)
                        return
                    }

                    // if it doesn't have a parent, it'll be moving to a parent level, so delete it...
                    Vue.delete(state.pages[ind].children, i)
                }
            })
        } // end if children
    }) // end foreach

    // if it exists, it'd have just been overwritten above
    if (alreadyExists) return

    // if it contains a parent...
    if (parentInd) {
        if (parent.children) state.pages[parentInd].children = [ ...parent.children, data ]
        else state.pages[parentInd].children = [ data ] // else create a new array with the data
        return
    }

    // else assign the page to the root...
    state.pages = [ ...state.pages, data ]
}

const removePage = (state, { pageInd, childInd }) => {
    if (childInd !== -1 && childInd !== undefined) {
        Vue.delete(state.pages[pageInd].children, childInd)
        return
    }
    else Vue.delete(state.pages, pageInd)
}

const setArticles = (state, articles) => state.articles = articles
const addNewArticle = (state, data) => state.articles = [data, ...state.articles]
const setArticleData = (state, { article, index }) => Vue.set(state.articles[index], 'body', article.body)
const removeArticle = (state, index) => Vue.delete(state.articles, index)

export default {
    [types.HIDE_AREA]: toggleHideAreaNav,
    [types.SET_LOGIN_CONTENT]: setLoginContent,
    [types.SET_PAGES]: setPages,
    [types.SET_PAGE_DATA]: setPage,
    [types.SET_NEW_PAGE]: setNewPage,
    [types.ADD_PAGE_TO_NAV]: addPageToNav,
    [types.REMOVE_PAGE]: removePage,
    [types.SET_SITE_ERROR]: setSiteError,
    [types.SET_ARTICLES]: setArticles,
    [types.ADD_NEW_ARTICLE]: addNewArticle,
    [types.SET_ARTICLE_DATA]: setArticleData,
    [types.REMOVE_ARTICLE]: removeArticle,
    [types.SET_PAGE_RESOURCES]: setPageResources,
    [types.UPDATE_RESOURCE]: updateResource,
    [types.DELETE_RESOURCE]: deleteResource
}
